export enum TicketTemplateStatus {
  Live = 'LIVE',
  Archived = 'ARCHIVED',
}
